import type { ConceptDef } from '../types';

export const sequenceDays: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-days',
  label: 'Sequence Days of Week',
  category: 'Sequencing',
  description: 'Tap days of the week in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Days of the week.', items: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] },
    ],
  },
};
